import AccordionDetails from '@mui/material/AccordionDetails';

export { AccordionDetails };
